<mat-card class="full-height padding-none">
  <mat-card-content class="padding-none">

    <mat-stepper  [linear]="true"
                  class="full-stretch"
                  labelPosition="end"
                  [selectedIndex]="stepIdxObs | async"
                  (selectionChange)="stepChange($event)"
                  [applyClassOnChild]="{
                    '.mat-horizontal-stepper-header-container':['border-primary-bottom', 'primary-background-A200-transparent']
                  }"
                  
    >

      <mat-step [hasError]="!(documentUploadStepValidObs | async)" [completed]="documentUploadStepValidObs | async"
        [label]="translate('ss-process-wizard.upload-documents-title') | async">
        <ss-document-upload-step></ss-document-upload-step>
      </mat-step>

      <mat-step   [hasError]="!(selectActivitesStepValidObs | async)" [completed]="selectActivitesStepValidObs | async"
        [label]="translate('ss-process-wizard.select-activities-title') | async">
        <ss-select-activities-step></ss-select-activities-step>
      </mat-step>

      <mat-step [label]="translate('ss-process-wizard.set-signatures-title') | async"
                [hasError]="!(selectTasksStepValidObs | async)" [completed]="selectTasksStepValidObs | async"
      >
        <ss-select-tasks-step *ngIf="(stepIdxObs | async) === 2"></ss-select-tasks-step>
      </mat-step>

      <mat-step [label]="translate('ss-process-wizard.review-title') | async">
        <ss-review-step class="display-block"></ss-review-step>
      </mat-step>
    </mat-stepper>
  </mat-card-content>

  <mat-card-footer   
    #footer
    class="border-primary-top padding-standard"
  >
    <div class="flex-row flex--align-center flex--justify-between">

      <div>
        <button (click)="back()" mat-raised-button class="stepper-button">
          <mat-icon>close</mat-icon>
          {{ "ss-process-wizard.process-back.display" | translate }}
        </button>
      </div>

      <div class="flex-row gap-standard flex--align-center">
        <button 
          *ngIf="!!(stepIdxObs | async)" 
          (click)="prev()" 
          class="prev-button stepper-button" 
          color="warn" 
          mat-raised-button
        >
          {{ "ss-general.back" | translate }}
        </button>

        <button 
          *ngIf="(stepIdxObs | async) !== 3" 
          (click)="tryNext()" 
          class="next-button stepper-button" 
          mat-raised-button
          color="primary"
        >
          {{ "ss-general.next" | translate }}
        </button>

        <button 
          *ngIf="(stepIdxObs | async) === 3"
          (click)="finishProcess()" 
          class="next-button stepper-button" 
          color="accent"
          mat-raised-button
          >
          {{ finishDisplayObs | async | translate }}
        </button>
      </div>
    
    </div>
  </mat-card-footer>
</mat-card>